import { SessionStore } from '../../constants';
import { AssessmentDetails, Task, TaskItem } from '../interfaces';
import { fetchLaunchConfigOfCompletedItemFromTask } from './fetchLaunchConfigOfCompletedItemFromTask';
import { persistPreviouslySelectedLanguage } from './persistPreviouslySelectedLanguage';
import taskItemStatusMapper from './taskItemStatusMapper';

const firstlaunchConfigOfCompletedItemOfAnyTask = (
  task: Task,
  taskItem: TaskItem,
  assessmentDetails: AssessmentDetails,
): string | undefined => {
  const currentWorkflowItem = sessionStorage.getItem(SessionStore.currentWorkflowItem);

  if (currentWorkflowItem) {
    try {
      const parsedCurrentWorkflowItem = JSON.parse(currentWorkflowItem);
      const { linearflow, tasks } = JSON.parse(parsedCurrentWorkflowItem.configuration).configWidgetJSON;
      const taskWithStatus = taskItemStatusMapper(tasks, parsedCurrentWorkflowItem.nestedItemsState);
      if (linearflow === 'true') {
        let launchConfig: string | undefined;

        for (const value of taskWithStatus) {
          const config = fetchLaunchConfigOfCompletedItemFromTask(value.items, value.items.length - 1);
          if (config) {
            launchConfig = config;
            break;
          }
        }

        if (launchConfig) {
          return persistPreviouslySelectedLanguage(launchConfig, taskItem.id, task.id, assessmentDetails);
        }
      }
    } catch (e) {
      console.error('Currentworkflow parse error: ', e);
    }
  }
};

export default firstlaunchConfigOfCompletedItemOfAnyTask;
